import React from 'react';
// Data
import {
  babyFormAdditionalMeta,
  babyFormStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import BabyFormMainContainer from '../../components/booking/BabyFormMainContainer';
import AltHeader from '../../components/general/AltHeader';
import HeaderBanner from '../../components/general/HeaderBanner';
import FooterComponent from '../../components/footer/FooterComponent';

function BabyForm() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Adult Baby Application'
        desc='Apply to be considered as an Adult Baby for Mistress Maria. Complete the form with your preferences, fantasies, and background to begin your journey into ABDL submission.'
        keywords='Adult Baby application, ABDL form, serve Mistress Maria, adult baby mistress, ABDL submission, nappy diaper lover application, adult baby roleplay, adult baby UK, apply to be an adult baby, ABDL experience'
        additionalMeta={babyFormAdditionalMeta}
        structuredData={babyFormStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid h-fit'>
          {/* Alt */}
          <AltHeader />

          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid pt-12'>
            <HeaderBanner message={'Domination Application Form'} />
          </header>
        </div>

        {/* Main page content */}
        <BabyFormMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default BabyForm;
